import React, { useEffect, useState } from 'react';
import { useOrg } from '../context/OrgContext';
import client from '../api/client';

export default function Maintenance() {
  const { branding } = useOrg();
  const [message, setMessage] = useState('The system is currently undergoing scheduled maintenance. Please check back shortly.');
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    client.get('/maintenance/status')
      .then(r => { if (r.data.message) setMessage(r.data.message); })
      .catch(() => {});
  }, []);

  const handleCheck = () => {
    setChecking(true);
    client.get('/maintenance/status')
      .then(r => {
        if (!r.data.maintenance) window.location.href = '/';
        else setChecking(false);
      })
      .catch(() => setChecking(false));
  };

  const primary = branding.primary_color || '#B71530';

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    }}>
      <div style={{ textAlign: 'center', maxWidth: '480px', padding: '32px 24px' }}>
        {/* Brand */}
        {branding.logo_url ? (
          <img src={branding.logo_url} alt={branding.display_name}
            style={{ maxHeight: '48px', marginBottom: '32px' }} />
        ) : (
          <div style={{ marginBottom: '32px' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              width: '56px', height: '56px', borderRadius: '12px',
              backgroundColor: primary, color: '#fff',
              fontSize: '20px', fontWeight: 700,
            }}>
              {(branding.display_name || 'AP')[0].toUpperCase()}
            </div>
            <div style={{ marginTop: '8px', fontWeight: 600, fontSize: '15px', color: '#343a40' }}>
              {branding.display_name || 'AP Automation'}
            </div>
          </div>
        )}

        {/* Icon */}
        <div style={{ marginBottom: '24px' }}>
          <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke={primary}
            strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </div>

        <h2 style={{ fontWeight: 700, fontSize: '24px', color: '#212529', marginBottom: '12px' }}>
          System Maintenance
        </h2>

        <p style={{ color: '#6c757d', fontSize: '15px', lineHeight: 1.6, marginBottom: '32px' }}>
          {message}
        </p>

        <button
          onClick={handleCheck}
          disabled={checking}
          style={{
            padding: '10px 28px',
            backgroundColor: primary,
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: 600,
            cursor: 'pointer',
            opacity: checking ? 0.7 : 1,
          }}
        >
          {checking ? 'Checking…' : 'Check Again'}
        </button>

        <p style={{ marginTop: '16px', fontSize: '12px', color: '#adb5bd' }}>
          This page refreshes automatically when the system comes back online.
        </p>

        <p style={{ marginTop: '24px', fontSize: '12px', color: '#adb5bd' }}>
          Are you an administrator?{' '}
          <a href="/login" style={{ color: '#6c757d', textDecoration: 'underline' }}>
            Sign in here
          </a>
        </p>
      </div>
    </div>
  );
}
